import { useState } from 'react';
import heroImage from '../assets/hero.webp';
import tractorImage from '../assets/tractor.webp';
import machine2 from '../assets/machine2.webp';
import machine3 from '../assets/machine3.webp';
import machine4 from '../assets/machine4.webp';
import Pesticides2 from '../assets/Pesticides2.webp';
import ploughImage from '../assets/plow.webp';


const FarmMachinery = () => {
  const [activeTab, setActiveTab] = useState('tractor');
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const machineryData = [
    {
      id: 'tractor',
      name: 'ट्रैक्टर',
      image: tractorImage,
      features: [
        'शक्तिशाली इंजन (45-120 HP)',
        'मल्टी-स्पीड ट्रांसमिशन',
        'हाइड्रोलिक सिस्टम',
        'फ्यूल एफिशिएंट',
        '4WD विकल्प उपलब्ध'
      ],
      description: 'ट्रैक्टर आधुनिक कृषि का मुख्य आधार है जो विभिन्न कृषि कार्यों को सुगम बनाता है।'
    },
    {
      id: 'plough',
      name: 'हल',
      image: ploughImage,
      features: [
        'मिट्टी की गुणवत्ता में सुधार',
        'खरपतवार नियंत्रण',
        'जल संरक्षण',
        'विभिन्न मिट्टी प्रकारों के लिए उपयुक्त',
        'डिस्क और मोल्डबोर्ड वेरायटी'
      ],
      description: 'हल मिट्टी को तैयार करने का पारंपरिक लेकिन आधुनिक रूप है जो बुवाई के लिए भूमि को तैयार करता है।'
    },
    {
      id: 'thresher',
      name: 'थ्रेशर',
      image: machine2,
      features: [
        'उच्च क्षमता (500-2000 kg/hr)',
        'कम बीज टूटना',
        'ऊर्जा कुशल',
        'मल्टी-क्रॉप संगत',
        'धूल नियंत्रण प्रणाली'
      ],
      description: 'थ्रेशर फसलों से अनाज को अलग करने में मदद करता है, जिससे मैनुअल श्रम की बचत होती है।'
    },
    {
      id: 'seeder',
      name: 'सीडर',
      image: machine3,
      features: [
        'सटीक बीज रखरखाव',
        'समय और श्रम की बचत',
        'विविध फसलों के लिए उपयुक्त',
        'उर्वरक ड्रिल के साथ संयोजन',
        'समान बीज गहराई'
      ],
      description: 'सीडर मशीनें बीज बोने की प्रक्रिया को स्वचालित करती हैं, जिससे उत्पादकता बढ़ती है।'
    },
    {
      id: 'sprayer',
      name: 'स्प्रेयर',
      image: Pesticides2,
      features: [
        'परिवर्तनीय नोजल',
        'हाथ से पकड़े जाने वाले से स्व-चालित तक',
        'कम ड्रिफ्ट तकनीक',
        'टैंक क्षमता (5-1000 लीटर)',
        'पीछे ले जाने योग्य और ट्रैक्टर माउंटेड विकल्प'
      ],
      description: 'स्प्रेयर कीटनाशकों, उर्वरकों और अन्य रसायनों के समान वितरण में मदद करते हैं।'
    },
    {
      id: 'harvester',
      name: 'हार्वेस्टर',
      image: machine4,
      features: [
        'संयुक्त हार्वेस्टिंग (कटाई, थ्रेशिंग, सफाई)',
        'GPS ट्रैकिंग सिस्टम',
        'उच्च क्षमता (2-8 एकड़/घंटा)',
        'कम फसल हानि',
        'स्वचालित समायोजन'
      ],
      description: 'हार्वेस्टर फसल कटाई को स्वचालित करते हैं, जिससे समय और श्रम की भारी बचत होती है।'
    }
  ];

  const rentalSchemes = [
    {
      name: 'कृषि यंत्र किराया सेवा',
      details: 'सरकार द्वारा समर्थित योजना जहां किसान प्रति घंटे/दिन के आधार पर मशीनरी किराए पर ले सकते हैं।'
    },
    {
      name: 'कस्टम हायरिंग सेंटर',
      details: 'स्थानीय सहकारी समितियों द्वारा संचालित, विशेष मौसमी आवश्यकताओं के लिए उपकरण उपलब्ध कराते हैं।'
    },
    {
      name: 'निजी किराया प्लेटफॉर्म',
      details: 'ऑनलाइन प्लेटफॉर्म जहां मशीन मालिक सीधे किसानों को उपकरण किराए पर दे सकते हैं।'
    }
  ];

  const subsidyInfo = [
    {
      scheme: 'राष्ट्रीय कृषि विकास योजना (RKVY)',
      benefit: 'कुल लागत का 50% तक (अधिकतम ₹5 लाख)'
    },
    {
      scheme: 'सब्सिडी पर कृषि यंत्र (SMAM)',
      benefit: 'छोटे और सीमांत किसानों के लिए 40-50% सब्सिडी'
    },
    {
      scheme: 'प्रधानमंत्री कृषि सिंचाई योजना',
      benefit: 'सिंचाई संबंधी उपकरणों पर विशेष सब्सिडी'
    }
  ];

  const maintenanceTips = [
    'नियमित रूप से इंजन तेल और फिल्टर बदलें',
    'उपयोग के बाद मशीन को अच्छी तरह साफ करें',
    'मौसमी भंडारण से पहले उचित स्नेहन करें',
    'निर्माता के निर्देशों के अनुसार नियमित जांच करें',
    'कटिंग ब्लेड और मूविंग पार्ट्स की तीक्ष्णता/स्थिति की जांच करें',
    'उचित ग्रेड के ईंधन और स्नेहक का उपयोग करें'
  ];

  const vendors = [
    {
      type: 'सरकारी',
      sources: [
        'कृषि विभाग, जिला कार्यालय',
        'कृषि तकनीकी प्रबंधक एजेंसी (ATMA)',
        'राज्य कृषि विपणन बोर्ड',
        'NABARD द्वारा अनुमोदित विक्रेता'
      ]
    },
    {
      type: 'निजी',
      sources: [
        'अधिकृत कंपनी डीलर (जॉन डीरे, महिंद्रा, Sonalika आदि)',
        'कृषि मेले और प्रदर्शनियाँ',
        'ऑनलाइन मार्केटप्लेस (AgroStar, TractorGuru)',
        'स्थानीय कृषि उपकरण दुकानें'
      ]
    }
  ];

  const faqs = [
    {
      question: 'कृषि यंत्रों के लिए सब्सिडी कैसे प्राप्त करें?',
      answer: 'सब्सिडी प्राप्त करने के लिए आपको अपने जिला कृषि अधिकारी के कार्यालय में आवेदन करना होगा, जिसमें जमीन के कागजात, आधार कार्ड और बैंक विवरण की आवश्यकता होती है।'
    },
    {
      question: 'मैं कृषि यंत्रों का परीक्षण कैसे कर सकता हूँ?',
      answer: 'अधिकांश सरकारी कृषि विज्ञान केंद्रों (KVKs) में प्रदर्शन इकाइयाँ हैं जहाँ आप मशीनों का परीक्षण कर सकते हैं। कई निजी डीलर भी परीक्षण के लिए उपकरण उपलब्ध कराते हैं।'
    },
    {
      question: 'कौन सा ट्रैक्टर छोटे किसानों के लिए सबसे उपयुक्त है?',
      answer: '25-35 HP रेंज के ट्रैक्टर छोटे किसानों के लिए आदर्श हैं क्योंकि वे किफायती हैं और सीमित भूमि पर विभिन्न कार्यों को संभाल सकते हैं।'
    },
    {
      question: 'मशीनरी रखरखाव के लिए कोई प्रशिक्षण कार्यक्रम?',
      answer: 'हाँ, कृषि विज्ञान केंद्र (KVKs) और राज्य कृषि विभाग नियमित रूप से मशीनरी रखरखाव पर प्रशिक्षण कार्यक्रम आयोजित करते हैं।'
    }
  ];

  return (
    <div className="mt-24">
      {/* Hero Section */}
      <div className="relative h-96 w-full overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-green-900 to-transparent opacity-90 z-10"></div>
        <img 
          src={heroImage} 
          alt="Farm Machinery" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center z-20 px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-white text-center animate-fade-in">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 to-green-200">
              आधुनिक कृषि यंत्र
            </span>
          </h1>
        </div>
      </div>

      {/* Importance Section */}
      <section className="py-12 px-4 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
            कृषि यंत्रों का महत्व
          </span>
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 border-l-4 border-green-500 hover:scale-105 transform transition">
            <h3 className="text-xl font-semibold text-green-700 mb-3">उत्पादकता में वृद्धि</h3>
            <p className="text-gray-700">मशीनीकरण से कृषि कार्यों की गति और दक्षता बढ़ती है, जिससे प्रति एकड़ उत्पादन में वृद्धि होती है।</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 border-l-4 border-yellow-500 hover:scale-105 transform transition">
            <h3 className="text-xl font-semibold text-yellow-700 mb-3">श्रम की बचत</h3>
            <p className="text-gray-700">मशीनें मैनुअल श्रम की आवश्यकता को कम करती हैं, जिससे किसानों का समय और ऊर्जा बचती है।</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 border-l-4 border-blue-500 hover:scale-105 transform transition">
            <h3 className="text-xl font-semibold text-blue-700 mb-3">लागत प्रभावी</h3>
            <p className="text-gray-700">दीर्घकाल में, मशीनीकरण से परिचालन लागत कम होती है और लाभप्रदता बढ़ती है।</p>
          </div>
        </div>
      </section>

      {/* Machinery Categories */}
      <section className="py-12 bg-gray-50 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
              विभिन्न कृषि यंत्र
            </span>
          </h2>
          
          {/* Tabs */}
          <div className="flex overflow-x-auto pb-2 mb-6 scrollbar-hide">
            <div className="flex space-x-2">
              {machineryData.map((item) => (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`px-4 py-2 rounded-full font-medium whitespace-nowrap transition-all duration-300 ${activeTab === item.id 
                    ? 'bg-green-600 text-white shadow-md' 
                    : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'}`}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
          
          {/* Tab Content */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            {machineryData.map((item) => (
              <div 
                key={item.id} 
                className={`p-6 md:p-8 transition-all duration-500 ${activeTab === item.id ? 'block' : 'hidden'}`}
              >
                <div className="flex flex-col md:flex-row gap-8">
                  <div className="md:w-1/2">
                    <img 
                      src={item.image} 
                      alt={item.name} 
                      className="w-full h-64 object-cover rounded-lg shadow-md hover:scale-105 transform transition duration-500"
                    />
                  </div>
                  <div className="md:w-1/2">
                    <h3 className="text-2xl font-bold text-green-800 mb-4">{item.name}</h3>
                    <p className="text-gray-700 mb-4">{item.description}</p>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">मुख्य विशेषताएँ:</h4>
                    <ul className="space-y-2">
                      {item.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <span className="text-green-500 mr-2">✓</span>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Rental Schemes */}
      <section className="py-12 px-4 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
            यंत्र किराया योजनाएँ
          </span>
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          {rentalSchemes.map((scheme, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-t-4 border-green-500 hover:-translate-y-1 transform transition"
            >
              <h3 className="text-xl font-semibold text-green-700 mb-3">{scheme.name}</h3>
              <p className="text-gray-700">{scheme.details}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Subsidy Information */}
      <section className="py-12 bg-gray-50 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
              सब्सिडी जानकारी
            </span>
          </h2>
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <table className="w-full">
              <thead className="bg-green-600 text-white">
                <tr>
                  <th className="py-3 px-4 text-left">योजना</th>
                  <th className="py-3 px-4 text-left">लाभ</th>
                </tr>
              </thead>
              <tbody>
                {subsidyInfo.map((item, index) => (
                  <tr 
                    key={index} 
                    className={`border-b border-gray-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-green-50 transition-colors`}
                  >
                    <td className="py-3 px-4 font-medium">{item.scheme}</td>
                    <td className="py-3 px-4">{item.benefit}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Maintenance Tips */}
      <section className="py-12 px-4 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
            यंत्र रखरखाव सुझाव
          </span>
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {maintenanceTips.map((tip, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border-l-4 border-yellow-500 flex items-start"
            >
              <span className="bg-yellow-100 text-yellow-800 rounded-full p-2 mr-3 flex-shrink-0">
                {index + 1}
              </span>
              <p className="text-gray-700">{tip}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Where to Get */}
      <section className="py-12 bg-gray-50 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
              यंत्र कहाँ से प्राप्त करें
            </span>
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {vendors.map((vendor, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow">
                <div className={`p-4 ${vendor.type === 'सरकारी' ? 'bg-green-600' : 'bg-blue-600'} text-white`}>
                  <h3 className="text-xl font-bold">{vendor.type} विक्रेता</h3>
                </div>
                <div className="p-6">
                  <ul className="space-y-3">
                    {vendor.sources.map((source, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className={`inline-block w-2 h-2 rounded-full mt-2 mr-2 ${vendor.type === 'सरकारी' ? 'bg-green-500' : 'bg-blue-500'}`}></span>
                        <span className="text-gray-700">{source}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-12 px-4 max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 text-green-800">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-600 to-yellow-600">
            अक्सर पूछे जाने वाले प्रश्न
          </span>
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="border border-gray-200 rounded-lg overflow-hidden transition-all duration-300"
            >
              <button
                className={`w-full p-4 text-left flex justify-between items-center ${openFaq === index ? 'bg-green-50' : 'bg-white'} hover:bg-green-50 transition-colors`}
                onClick={() => toggleFaq(index)}
              >
                <span className="font-medium text-gray-800">{faq.question}</span>
                <span className={`transform transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`}>
                  <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </span>
              </button>
              <div 
                className={`px-4 pb-4 pt-2 bg-green-50 transition-all duration-300 ${openFaq === index ? 'block' : 'hidden'}`}
              >
                <p className="text-gray-700">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default FarmMachinery;